import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   //Load the React code when we initialize
   initialize() {
      this.componentPromise = import("../react/components/app");
   }

   async connect() {
      this.component = await this.componentPromise;
      this.component.render(this.element);
   }

   disconnect() {
      this.component.destroy(this.element);
   }
}
